module.exports = require("lodash/toNumber");